<script setup>
import MyOrders from '@/views/orders/myOrders.vue'
import MyActivities from '@/views/activities/myActivities.vue'
import { onMounted, ref } from 'vue'
import { useUserStore } from '@provise/stores/user.js'

const userStore = useUserStore()

const tabs = {
  ordersMy: 'Мои заявки',
  ordersGroup: 'Назначенные заявки',
  activities: 'Согласовать план отгрузки',
}

const tabsAvail = ref([])
const tab = ref()

onMounted(() => {
  let ta = []

  if (userStore.can(['manager', 'supermanager'])) {
    ta = ['activities']
  }

  if (userStore.can(['orders_view', 'orders_edit'])) {
    ta = [...ta, 'ordersGroup', 'ordersMy']
  }

  tab.value = ta[0]
  tabsAvail.value = ta
})
</script>
<template>
  <div class="nav nav-tabs">
    <div
      class="nav-item"
      v-for="tTitle of tabsAvail"
      :key="tTitle"
    >
      <a
        href="#"
        class="nav-link"
        :class="{ active: tab == tTitle }"
        @click.prevent="tab = tTitle"
      >
        {{ tabs[tTitle] }}
      </a>
    </div>
  </div>

  <div class="workspace inner">
    <MyOrders
      filter="my"
      v-if="tab == 'ordersMy'"
    />
    <MyOrders
      filter="group"
      v-if="tab == 'ordersGroup'"
    />
    <MyActivities
      filter="group"
      v-if="tab == 'activities'"
    />
  </div>
</template>
